export const ENERGY_LEVELS = ["low", "medium", "high"] as const;
export const TEMPERAMENTS = ["shy", "neutral", "forward"] as const;

export type EnergyLevel = (typeof ENERGY_LEVELS)[number];
export type Temperament = (typeof TEMPERAMENTS)[number];

export const energyLevelOptions = [
  { value: ENERGY_LEVELS[0], label: "Low" },
  { value: ENERGY_LEVELS[1], label: "Medium" },
  { value: ENERGY_LEVELS[2], label: "High" },
];

export const temperamentOptions = [
  { value: TEMPERAMENTS[0], label: "Shy" },
  { value: TEMPERAMENTS[1], label: "Neutral" },
  { value: TEMPERAMENTS[2], label: "Forward" },
];
